/**
 * Custom collapsible description for product descriptions
 * Adds read more/read less toggle functionality
 */
document.addEventListener('DOMContentLoaded', function() {
  const descriptionContents = document.querySelectorAll('.description-content');
  const readMoreButtons = document.querySelectorAll('.read-more-toggle');
  
  // Set up each description with its toggle button
  if (descriptionContents.length > 0 && readMoreButtons.length > 0) {
    readMoreButtons.forEach((button, index) => {
      const content = descriptionContents[index];
      
      // Initial setup - check if content needs a toggle
      const needsToggle = content.scrollHeight > content.clientHeight;
      if (!needsToggle) {
        button.style.display = 'none';
        content.classList.remove('collapsed');
        return;
      }
      
      // Add click event listener
      button.addEventListener('click', function() {
        if (content.classList.contains('collapsed')) {
          content.classList.remove('collapsed');
          button.textContent = 'Read less';
        } else {
          content.classList.add('collapsed');
          button.textContent = 'Read more';
        }
      });
    });
  }
});